import React from 'react'
import supportImg  from "../../src/./images/support.jpg"
import { FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';


const Support = () => {
  return (
    <aside className="support-aside">
        <h2 className="support-title">Excellent Support System</h2>

        <div className="support-text-container">
            <p className="support-text">
                We love our customer and they can reach us any time of the day we will be at your service 24/7.
            </p>
            <span><IoIosArrowDown /></span>
        </div>

        <div className="support-details">
            <div className="support-overlay"></div>
            
            <div className="support-img-container">
                <img src={supportImg} className="support-img" alt="" />
            </div>

            <div className="support-team">
                <a href="mailto:mailto:aremudami58@gmail.com">Email <small><FaEnvelope /></small></a>
                <a href="https://wa.me/+2348156959983"> Whatsapp <small><FaWhatsapp /></small></a>
                <a href="tel:+2348156959983">Phone <small><FaPhone /></small></a>
            </div>
        </div>
  </aside>
  )
}

export default Support